<template>
	<div class="page" data-name="points">
		<div class="page-content infinite-scroll-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					보너스 포인트
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>				
			<div class="list">
				<ul>
					<li class="item-content item-input">
						<div class="item-inner">
							<div class="item-title item-label">학습 타입</div>
							<div class="item-input-wrap input-dropdown-wrap">						
								<select placeholder="-학습타입을 선택하세요-" v-model="studyType" @change="onStudyTypeChanged">
									<option value="">-전체-</option>
									<template v-for="(item, i) in studyTypeList">
										<option :key="'i'+i" :value="item.id">{{item.name}}</option>
									</template>
								</select>						
							</div>
						</div>
					</li>
				</ul>
			</div>			
			<div class="list">
				<ul>
					<template v-for="(item, i) in pointList">
						<li :key="'ii' + i">						
							<div class="item-content item-inner">
								<div class="item-title">
									<div class="item-header">{{item.POINT}} 포인트
											- <small>{{displayUpdataTime(item.UPDATE_DATETIME)}}</small>
									</div>
										{{item.STUDY_NAME}}({{item.EXAM_CNT}}문제) (맞춘문제 : {{item.O_CNT}} 틀린문제 : {{item.X_CNT}})
									
								</div>
								<div class="item-after">
									<span class="badge">{{getStudyTypeName(i)}}</span>
								</div>
							</div>					
						</li>
					</template>
				</ul>
			</div>
			<div class="preloader infinite-scroll-preloader" style="display:none"></div>
		</div>		
	</div>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {
			pageNo: 1,
			pageSize: 30,
			allowInfinite: true,
			maxPageNo: 0,		
			pointList: [],
			studyTypeList: [],
			studyType:""
		}
	},

	mounted() {
		const _this = this;
		_this.setStudyTypeList();
		_this.loadMyPointList();
		$('.infinite-scroll-content').on('infinite',_this.onInfinite);		
	},
	methods: {
		onInfinite(){
			const _this = this;

			if(!_this.allowInfinite) return;
			_this.allowInfinite = false;
			
			$('.infinite-scroll-preloader').show();				
			
			setTimeout(function () {
				_this.allowInfinite = true;

				if(_this.pageNo >= _this.maxPageNo){			
					_this.$f7.infiniteScroll.destroy('.infinite-scroll-content');
					$('.infinite-scroll-preloader').remove();				
      		return;
				}			

				_this.loadMyPointList();

			}, 1000);
		},	
		getStudyTypeName(itemIndex) {
			const _this = this;
			var item = _this.pointList[itemIndex];
			var studyTypeName = CONST.studyType[item.STUDY_TYPE].name;

			return studyTypeName;
		},
		displayUpdataTime(updateTime) {
			var formatDate = moment(updateTime).format("YY.MM.DD");			
			return formatDate;
		},
		setStudyTypeList() {
			const _this = this;
			
			_this.studyTypeList = Object.values(CONST.studyType);						
		},
		onStudyTypeChanged() {
			const _this = this;
			_this.loadMyPointList();
		},
		loadMyPointList() {
			const _this = this;
			var type = "";
		
			if(_this.studyType != "" && _this.studyType != undefined) {
				type = _this.studyType;
			}

			let param = {
				pStudyType : type,
				pPageNo : _this.pageNo,
				pPageSize : _this.pageSize
			}

			API.ajaxRequest({
				url: API.getMyPointListUrl(),
				data: param
			}).then(function (data) {

				if(data.pointList.length > 0 ) {
					
					for(var i = 0; i < data.pointList.length; i++) {
						var pointItem = data.pointList[i];
						_this.pointList.push(pointItem);
					}
					_this.pageNo += 1;	
					_this.maxPageNo = data.totalPageCount;
				}

				$('.infinite-scroll-preloader').hide();
								
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		}
	}
}
</script>
